import cn from 'classnames';
import type { StaticImageData } from 'next/image';
import { isValidElement } from 'react';

import { Card } from '@sravni/react-design-system/lib/Card';
import { Heading, type HeadingProps, Text } from '@sravni/react-design-system/lib/Typography';

import { Image } from '@/components/Image';

import type { AdvantageItem } from '../types';

import styles from './styles.module.scss';

type AdvantagesCardProps = AdvantageItem &
  Omit<React.AllHTMLAttributes<HTMLDivElement>, 'title'> & {
    titleLevel?: HeadingProps['level'];
    direction?: 'vertical' | 'horizontal';
  };

export const AdvantagesCard = ({
  title,
  desc,
  img,
  variant,
  className,
  titleLevel = 3,
  direction = 'vertical',
  ...props
}: AdvantagesCardProps) => (
  <Card
    {...props}
    color="dark"
    className={cn(
      className,
      styles.card,
      styles[`card-variant--${variant}`],
      styles[`card-direction--${direction}`],
      !img && styles[`card--without-img`],
    )}
    size={24}
  >
    {typeof title === 'string' ? (
      <Heading className={styles.title} level={titleLevel}>
        {title}
      </Heading>
    ) : (
      title
    )}
    {desc &&
      (typeof desc === 'string' ? (
        <Text className={cn(styles.desc, 'whitespace-pre-line', !img && 'h-color-D60')} size={16}>
          {desc}
        </Text>
      ) : (
        desc
      ))}
    {img &&
      (isValidElement(img) ? (
        img
      ) : (
        <Image className={styles.img} alt="advantages-card-img" {...(img as StaticImageData)} />
      ))}
  </Card>
);
